import { Injectable } from '@angular/core';
import moment, { DurationInputArg2 } from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateConfigService {

  constructor() { }

  getCalculatedDate(unitValue?: number, direction?: 'future' | 'past', dependentDate?: Date, maxEndDate?: Date, unit: DurationInputArg2 = 'days'): Date {
    if (!unitValue) return null;
    const base = dependentDate ? moment(dependentDate) : moment();
    const result = direction === 'future' ? base.add(unitValue, unit).startOf('day') : base.subtract(unitValue, unit).startOf('day');
    return maxEndDate && (direction === 'future' ? moment(maxEndDate).isBefore(result) : moment(maxEndDate).isAfter(result)) ? maxEndDate : result.toDate();
  }

  getMinMaxDate(dates: (Date | number)[], type: 'min' | 'max'): Date | null {
    if (!dates || dates.length === 0) return null;
    const normalizedDates = this.normalizeDates(dates);
    const moments = normalizedDates.map(d => moment(d)).filter(m => m.isValid());
    if (moments.length === 0) return null;
    const result = type === 'min' ? moment.min(moments) : moment.max(moments);
    return result.toDate();
  }

  normalizeFutureDateToToday(dates: (Date | null | undefined)[]): Date | null {
    for (const element of dates) {
      if (!element) continue;
      const m = moment(element);
      if (!m.isValid()) continue;
      return m.isAfter(moment(), 'day') ? moment().toDate() : m.toDate();
    }
    return null;
  }

  private normalizeDates(dates: (Date | number)[]): Date[] | null {
    if (!dates || dates.length === 0) return null;

    const normalized = dates
      .map(item => {
        if (item === null || item === undefined) {
          return null;
        }
        if (typeof item === 'number' && item.toString().length < 9) {
          return moment().add(item, 'days').toDate();
        }
        const m = moment(item);
        return m.isValid() ? m.toDate() : null;
      })
      .filter((d): d is Date => d !== null);

    return normalized.length ? normalized : null;
  }
}
